const HERO_IMG =
  "https://readdy.ai/api/search-image?query=Playful%20modern%20flat%20illustration%20of%20a%20giant%20friendly%20watermelon%20slice%20with%20a%20smile%20surrounded%20by%20colorful%20speech%20bubbles%20and%20small%20cheerful%20crowd%20onlookers%20watching%20and%20discussing%2C%20warm%20coral%20red%20fresh%20watermelon%20green%20and%20soft%20cream%20palette%2C%20clean%20minimal%20flat%20design%2C%20gentle%20even%20lighting%2C%20no%20text&width=1600&height=900&seq=hero-2026-x1&orientation=landscape";

const FLOAT_TAGS = [
  { icon: "ri-fire-line", text: "热议中" },
  { icon: "ri-chat-1-line", text: "神评扎堆" },
  { icon: "ri-bubble-chart-line", text: "弹幕不断" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-24">
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="吾爱吃瓜 西瓜主题插画，吃瓜群众围观热议话题"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background-50/95 via-background-50/70 to-accent-100/50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 md:px-6 py-16 md:py-24 text-center">
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-4 py-1.5 text-sm text-primary-700">
          <span>🍉</span>
          全网热闻 · 一起围观
        </span>

        <h1 className="font-heading mt-6 max-w-3xl text-4xl md:text-6xl leading-tight text-foreground-950 text-balance">
          今天，你<span className="text-primary-600">吃瓜</span>了吗？
        </h1>

        <p className="mt-5 max-w-2xl text-base md:text-lg leading-relaxed text-foreground-700">
          汇聚全网网友评论与评论区热议，吃瓜群众在这里围观、站队、开麦、玩弹幕。
          看看大家都在说什么，参与热门话题的讨论。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 w-full">
          <a
            href="#topics"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-base text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-eye-line"></i>
            开始围观
          </a>
          <a
            href="#board"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/90 px-7 py-3 text-base text-foreground-800 ring-1 ring-background-300 hover:bg-background-50 hover:ring-primary-300 transition-colors"
          >
            <i className="ri-fire-line text-primary-600"></i>
            看看热议榜
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          {FLOAT_TAGS.map((tag) => (
            <span
              key={tag.text}
              className="float-soft inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-4 py-2 text-sm text-accent-800"
            >
              <i className={tag.icon}></i>
              {tag.text}
            </span>
          ))}
          <span className="hidden sm:inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm text-foreground-600 ring-1 ring-background-200">
            <i className="ri-group-line text-accent-600"></i>
            今日围观人数 <b className="text-foreground-900">128.6w</b>
          </span>
        </div>
      </div>
    </section>
  );
}